<template>
  <div v-if="show">
    <div class="modal olympic-modal letter fade show" style="display: block;" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="title-with-icon">
              <div class="title-with-icon__icon title-with-icon__icon_login"></div>
              <div class="title-with-icon__title">
                <span class="title-letter">Статус участия в олимпиаде</span>
              </div>
            </div>
            <button type="button" class="close modal-close" @click="$emit('close')" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="isLoading" class="text-center">
              <p>Проверяем ваш статус...</p>
            </div>
            <div v-else-if="userStatus === 'not_authenticated'" class="text-center">
              <p class="mb-3">Для участия в олимпиаде необходимо авторизоваться или зарегистрироваться.</p>
              <button @click="$emit('register')" class="btn btn-primary">Зарегистрироваться</button>
            </div>
            <div v-else-if="userStatus === 'has_application'" class="text-center">
              <p class="mb-3 text-success">Вы уже зарегистрированы на олимпиаду!</p>
              <p>Следите за обновлениями в личном кабинете.</p>
            </div>
            <div v-else-if="userStatus === 'no_application'" class="text-center">
              <p class="mb-3">Вы авторизованы, но еще не зарегистрированы на олимпиаду.</p>
              <button @click="$emit('register')" class="btn btn-primary">Зарегистрироваться</button>
            </div>
            <div v-else-if="userStatus === 'error'" class="text-center">
              <p class="mb-3 text-danger">Произошла ошибка при проверке статуса.</p>
              <button @click="$emit('close')" class="btn btn-secondary">Закрыть</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop show"></div>
  </div>
</template>

<script>
export default {
  name: 'OlympicsStatusModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    userStatus: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'register']
}
</script>
